import { useLocation, useNavigate } from "react-router-dom";
import { readRedirectTo } from "@/features/auth/utils/post-auth-redirect";
import { RealtorOnboardingFlow } from "@/features/onboarding/components/realtor-onboarding-flow";
import { useLeaveOnceOnboarded } from "@/features/onboarding/hooks/use-leave-once-onboarded";
import { useOnboardingPrefill } from "@/features/onboarding/hooks/use-onboarding-prefill";
import {
	OnboardingExitControl,
	useOnboardingExit,
} from "@/features/roles/components/back-to-role";

export function RealtorOnboardingPage() {
	const navigate = useNavigate();
	const location = useLocation();
	// Set when a route guard diverted the visitor here mid-journey; the
	// page they were heading for outranks this role's landing page.
	const redirectTo = readRedirectTo(location.state);
	const markCompletedHere = useLeaveOnceOnboarded(redirectTo ?? "/dashboard");
	const exit = useOnboardingExit(() =>
		navigate("/onboarding", {
			state: {
				allowSelection: true,
				...(redirectTo ? { redirectTo } : {}),
			},
		}),
	);

	// Only an account adding a role has details to carry over.
	const addingRole = exit.backTo !== null;
	const prefill = useOnboardingPrefill(addingRole);

	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-dashboard-warm-350 px-4 py-8">
			<div className="w-full max-w-2xl">
				<RealtorOnboardingFlow
					onExit={exit.onExit}
					exitControl={<OnboardingExitControl exit={exit} />}
					showPhoto={addingRole}
					prefill={prefill}
					onProfileCreated={markCompletedHere}
					// The realtor lands on the dashboard. From there, the CRM is usable
					// but public surfaces show locked-state UI pointing to verification.
					onFinished={() => navigate(redirectTo ?? "/dashboard")}
				/>
			</div>
		</div>
	);
}
